"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameRecordings = void 0;
var NameRecordings;
(function (NameRecordings) {
    NameRecordings["No"] = "No";
    NameRecordings["MarchingOrder"] = "MarchingOrder";
    NameRecordings["AudioAi"] = "AudioAi";
    NameRecordings["SelfRecord"] = "SelfRecord";
    NameRecordings["ThirdParty"] = "ThirdParty";
})(NameRecordings = exports.NameRecordings || (exports.NameRecordings = {}));
//# sourceMappingURL=name-recordings.js.map